import { gsap, Power2 } from "gsap";
import './gsap.css';

// Gsapアニメーションを管理するクラス
export class GsapAnimation
{
  /**
   * 要素が下から上へ出現するアニメーション
   * 
   * @param elements, delay
   * @return void
   */
  bottomToTop = ( elements, duration = 0, delay = 0 ) => {
    gsap.to( elements.children, { 
      y: 0,
      duration: duration,
      delay: delay,
      ease: "expo.inOut",
    } );
  }

  /**
   * テキストが一文字ずつ出現するアニメーション
   */
  textSplit = ( elements ) => {
    gsap.to( elements.children, {
      y: 0 /*テキストのY軸の操作*/,
      stagger: 0.02 /*テキスト間の遅延時間*/,
      delay: 0.1 /*アニメーションのスタートまでの遅延時間*/,
      duration: 0.15 /*アニメーションの時間*/,
      ease: Power2.out /*イージングの設定*/,
    } );
  }
}
